import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, FIELD_SPACE, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import Typography from "@material-ui/core/Typography";
import Space from "../../commons/Space";
import {BORDER_RADIUS} from "../../../../styles/Styles";
import {
  doInitiateVerifyAccount,
  resetInitiateVerifyAccountErrMsg
} from "../../../actions/profileActions";
import DialogView from "../../commons/DialogView";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";

const useStyles = () => ({
});

class InitiateVerifyAccount extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showSnackbar: false,
    }
  }

  componentDidMount() {
    this.props.doInitiateVerifyAccount().then(() => {
      this.showSnackbar({
        snackbarMessageId: 'login.resendVerificationLinkSuccess'
      });
    });
  }

  render() {
    return (
      <div>
        {this.renderDialogView()}
        {this.renderSnackBar()}
      </div>
    );
  }

  renderDialogView() {
    const {classes, profile} = this.props;

    let errorMessage = null;
    if (profile) {
      if (profile.errMsgIVA) {
        errorMessage = <FormattedMessage id={profile.errMsgIVA} />;
      } else if (profile.errMsgIVAF) {
        errorMessage = profile.errMsgIVAF;
      }
    }
    if (!errorMessage) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={true}
        title={this.context.intl.formatMessage({id: 'login.resendVerificationLinkFailed'})}
        message={errorMessage}
        positiveText={this.context.intl.formatMessage({id: 'generic.ok'})}
        onPositiveClicked={this.hideDialog}
      />
    );
  }

  hideDialog = () => {
    this.props.onDone(0);
    this.props.resetInitiateVerifyAccountErrMsg();
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      return (
        <Snackbar open={snackbarMessageId || snackbarMessage} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={this.onCloseSnackbar}>
          <MuiAlert severity={snackbarType || "success"} onClose={this.onCloseSnackbar} elevation={6} variant="filled" style={{borderRadius: BORDER_RADIUS}}>
            {snackbarMessageId ? <FormattedMessage id={snackbarMessageId}/> : null}
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  onCloseSnackbar = () => {
    this.props.onDone(1);
    this.setState({showSnackbar: false, snackbarInfo: null});
  }

}

InitiateVerifyAccount.propTypes = {
  classes: PropTypes.object,
  app: PropTypes.object,
  user: PropTypes.object,
  intl: PropTypes.object,
};

InitiateVerifyAccount.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    isLoading: state.isLoading,
    profile: state.admin.profile
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetInitiateVerifyAccountErrMsg: () => dispatch(resetInitiateVerifyAccountErrMsg()),
    doInitiateVerifyAccount: (data) => dispatch(doInitiateVerifyAccount()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
  ])(InitiateVerifyAccount))
);
